module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/6d913b8a6339e89cb9e15d50b455a02e.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Gold/Gold2.svg
// module id = wBUB
// module chunks = 1